// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__P355h","label":"styles_label__nawb4","select":"styles_select__Cyoj8","error":"styles_error__UGgKb","labelGap":"styles_labelGap__UU9Tg"};